import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalJourneyTaskAttachment } from "./types";

// GET /api/portal/journeys/progress/:progressId/attachments — per-task
// attachment list. Subscribed by task-proof-input when the task's action
// kind is `attachment`. Optimistic upload + remove are handled by the
// mutation hooks; this query just provides the canonical post-settle row.

export function useJourneyTaskAttachments(
  progressId: string | null,
  options: { enabled?: boolean } = {},
) {
  return useQuery<PortalJourneyTaskAttachment[]>({
    queryKey: queryKeys.portal.journeys.taskAttachments(progressId ?? ""),
    queryFn: () =>
      apiFetch<PortalJourneyTaskAttachment[]>(
        `/portal/journeys/progress/${progressId}/attachments`,
      ),
    enabled: !!progressId && options.enabled !== false,
  });
}
